import CONFIG from '../../globalVariables';

const resolveImageUrl = (url) => {
  if (!url) return '';
  const u = String(url);
  const hasProtocol = u.startsWith('http://') || u.startsWith('https://');
  const looksLikeDomain = /^[a-z0-9.-]+(\.[a-z0-9.-]+)+(\/|$)/i.test(u);
  if (hasProtocol) return u;
  if (looksLikeDomain) return `https://${u.replace(/^https?:\/\//, '')}`;
  if (u.startsWith('/images/')) return u;
  if (u.startsWith('/uploads/')) return `${CONFIG.PATH_API}${u}`;
  if (u.includes('/uploads/')) {
    const norm = u.startsWith('/') ? u : `/${u}`;
    return `${CONFIG.PATH_API}${norm}`;
  }
  if (u.startsWith('/')) return u;
  return `${CONFIG.PATH_API}/uploads/${u.replace(/^\//, '')}`;
};

export default resolveImageUrl;
